import repository from "../Repository";

export default {
  /**
   * 参照API
   * @param {*} screenId 画面ID
   * @param {*} payload ペイロード
   */
  async list(screenId, payload) {
    return await repository.post(`lalert_info`, payload, {
      headers: {
        s: screenId
      }
    });
  },

  /**
   * 登録API
   * @param {*} screenId 画面ID
   * @param {*} payload ペイロード
   */
  async create(screenId, payload) {
    return await repository.post(`lalert_info_ope`, payload, {
      headers: {
        s: screenId
      }
    });
  },

  /**
   * 編集API
   * @param {*} screenId 画面ID
   * @param {*} payload ペイロード
   */
  async update(screenId, payload) {
    return await repository.patch(`lalert_info_ope`, payload, {
      headers: {
        s: screenId
      }
    });
  }
};
